import { FormattedMessage, useIntl } from 'react-intl';

export interface HeaderProps {
  isScrolled?: boolean;
  onLoginClick: () => void;
  onSignUpClick: () => void;
  onScrollToFeatures: () => void;
  onScrollToPricing: () => void;
  onScrollToContact?: () => void;
}

const Header = ({ onLoginClick, onSignUpClick, onScrollToFeatures, onScrollToPricing }: HeaderProps) => {
  const intl = useIntl();
  return (
    <nav className="nav" aria-label="Navegación principal">
      <div className="brand">
        <div className="brand-mark">
          <img src="/logo512.png" alt="TrainEase" />
        </div>
        <span className="brand-name">TrainEase</span>
      </div>
      <div className="nav-links">
        <a onClick={onScrollToFeatures}>
          <FormattedMessage id="landing.nav.product" defaultMessage="Producto" />
        </a>
        <a href="#coaches">
          <FormattedMessage id="landing.nav.coaches" defaultMessage="Para coaches" />
        </a>
        <a href="#atletas">
          <FormattedMessage id="landing.nav.athletes" defaultMessage="Para atletas" />
        </a>
        <a onClick={onScrollToPricing}>
          <FormattedMessage id="landing.nav.pricing" defaultMessage="Precios" />
        </a>
        <a href="#faq">
          <FormattedMessage id="landing.nav.faq" defaultMessage="FAQ" />
        </a>
      </div>
      <div className="nav-cta">
        <button className="btn-ghost" type="button" onClick={onLoginClick}>
          {intl.formatMessage({ id: 'landing.nav.login', defaultMessage: 'Iniciar sesión' })}
        </button>
        <button className="btn-lime" type="button" onClick={onSignUpClick}>
          {intl.formatMessage({ id: 'landing.nav.start', defaultMessage: 'Comenzar gratis' })}
        </button>
      </div>
    </nav>
  );
};

export default Header;
